<script setup lang="ts">
import { IconMoon, IconSun } from "@iconify-prerendered/vue-carbon";

import { useDark, useToggle } from "@vueuse/core";

const isDark = useDark();
const toggleDark = useToggle(isDark);
</script>

<template>
  <button
    @click="toggleDark()"
    class="w-12 h-12 rounded-full flex justify-center items-center select-none cursor-pointer transition-colors bg-gray-800 hover:bg-gray-700 text-white"
  >
    <component
      :is="isDark ? IconSun : IconMoon"
      class="w-6 h-6"
    />
  </button>
</template>

<style scoped lang="scss"></style>
